import React from 'react';

const TextArea = (props) => {
    return (
      <div className={`field-wrapper ${props.labelPositionTop && 'label-on-top'}`}>
        <label className="field-label">{ props.label }</label>
        <div className="field">
          <textarea
            name=""
            id=""
            value={props.value}
            onChange={props.onChange}
          />
        </div>
        {
          props.error &&
          <div style={{ color: 'red' }}>
            {props.error.map((message) => message)}
          </div>
        }
      </div>
    );
}

export { TextArea };
